var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-spacer'),_c('qr-code',{staticClass:"qr",attrs:{"text":_vm.text,"value":_vm.text,"size":_vm.size,"color":"black","bg-color":"white","error-level":"L"}}),_c('v-spacer')],1),_c('v-row',[_c('v-spacer'),_c('h2',{staticClass:"mt-8"},[_vm._v(_vm._s(_vm.code))]),_c('v-spacer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }